import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const FarmGaleriesWrapper = styled.div`
  display: flex;
  flex-direction: column;

  .youtube-video-wrapper {
    margin-top: 16px;
    display: flex;
    justify-content: center;

    iframe {
      width: 470px;
      height: 200px;
    }

    @media (max-width: ${breakpoints.md}px) {
      iframe {
        width: 100%;
        height: auto;
        aspect-ratio: 3 / 2;
      }
    }

    @media (max-width: ${breakpoints.xs}px) {
      padding: 0 20px;

      iframe {
        width: 100%;
        aspect-ratio: 3 / 2;
      }
    }
  }

  .gallery-images-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: center;
    align-items: center;

    .farm-gallery-image-container {
      width: 300px;
      height: 200px;
      flex: 1 1 auto;
      overflow: hidden;
      position: relative;

      .ant-image,
      .ant-image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }

    @media (max-width: ${breakpoints.md}px) {
      .farm-gallery-image-container {
        width: 100%;
        height: auto;
      }

      .ant-image,
      .ant-image img {
        height: 100%;
      }
    }

    @media (max-width: ${breakpoints.xs}px) {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
      gap: 10px;
      padding: 20px;

      .farm-gallery-image-container {
        position: relative;
        width: 100%;
        aspect-ratio: 3 / 2;
        border-radius: 5px;
        overflow: hidden;
      }

      .ant-image,
      .ant-image img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    }
  }
`;
